/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BadRequestError from '../model/BadRequestError';
import ContentTaxonCreate from '../model/ContentTaxonCreate';
import ContentTaxonList from '../model/ContentTaxonList';
import ContentTaxonRead from '../model/ContentTaxonRead';
import ForbiddenError from '../model/ForbiddenError';
import InlineObject21 from '../model/InlineObject21';
import NotAcceptableError from '../model/NotAcceptableError';
import NotFoundError from '../model/NotFoundError';
import ServiceUnavailableError from '../model/ServiceUnavailableError';
import TaxonBagCreate from '../model/TaxonBagCreate';
import TaxonBagList from '../model/TaxonBagList';
import TaxonBagRead from '../model/TaxonBagRead';
import TaxonBagUpdate from '../model/TaxonBagUpdate';
import TaxonCreate from '../model/TaxonCreate';
import TaxonList from '../model/TaxonList';
import TaxonRead from '../model/TaxonRead';
import TaxonState from '../model/TaxonState';
import TaxonStateUpdate from '../model/TaxonStateUpdate';
import TaxonUpdate from '../model/TaxonUpdate';
import TaxonVersionList from '../model/TaxonVersionList';
import TaxonVersionRead from '../model/TaxonVersionRead';
import TaxonVersionWrite from '../model/TaxonVersionWrite';
import TaxonomyCreate from '../model/TaxonomyCreate';
import TaxonomyList from '../model/TaxonomyList';
import TaxonomyRead from '../model/TaxonomyRead';
import TaxonomyUpdate from '../model/TaxonomyUpdate';
import UnauthorizedError from '../model/UnauthorizedError';

/**
* Taxonomy service.
* @module api/TaxonomyApi
* @version 1.7.2
*/
export default class TaxonomyApi {

    /**
    * Constructs a new TaxonomyApi. 
    * @alias module:api/TaxonomyApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createContentTaxon operation.
     * @callback module:api/TaxonomyApi~createContentTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContentTaxonRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a ContentTaxon resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} entityName 
     * @param {String} entityId 
     * @param {String} bagName 
     * @param {module:model/ContentTaxonCreate} contentTaxon Required properties are: * taxon 
     * @param {module:api/TaxonomyApi~createContentTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContentTaxonRead}
     */
    createContentTaxon(acceptLanguage, entityName, entityId, bagName, contentTaxon, callback) {
      let postBody = contentTaxon;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createContentTaxon");
      }
      // verify the required parameter 'entityName' is set
      if (entityName === undefined || entityName === null) {
        throw new Error("Missing the required parameter 'entityName' when calling createContentTaxon");
      }
      // verify the required parameter 'entityId' is set
      if (entityId === undefined || entityId === null) {
        throw new Error("Missing the required parameter 'entityId' when calling createContentTaxon");
      }
      // verify the required parameter 'bagName' is set
      if (bagName === undefined || bagName === null) {
        throw new Error("Missing the required parameter 'bagName' when calling createContentTaxon");
      }
      // verify the required parameter 'contentTaxon' is set
      if (contentTaxon === undefined || contentTaxon === null) {
        throw new Error("Missing the required parameter 'contentTaxon' when calling createContentTaxon");
      }

      let pathParams = {
        'entity_name': entityName,
        'entity_id': entityId,
        'bag_name': bagName
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ContentTaxonRead;
      return this.apiClient.callApi(
        '/{entity_name}/{entity_id}/taxons/{bag_name}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createTaxon operation.
     * @callback module:api/TaxonomyApi~createTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Taxon resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {module:model/TaxonCreate} taxon Required properties are: * title   For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/TaxonomyApi~createTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonRead}
     */
    createTaxon(acceptLanguage, taxonomyName, taxon, callback) {
      let postBody = taxon;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling createTaxon");
      }
      // verify the required parameter 'taxon' is set
      if (taxon === undefined || taxon === null) {
        throw new Error("Missing the required parameter 'taxon' when calling createTaxon");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createTaxonBag operation.
     * @callback module:api/TaxonomyApi~createTaxonBagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonBagRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a TaxonBag resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {module:model/TaxonBagCreate} taxonBag Required properties are: * name * sortable * taxonomy 
     * @param {module:api/TaxonomyApi~createTaxonBagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonBagRead}
     */
    createTaxonBag(acceptLanguage, taxonBag, callback) {
      let postBody = taxonBag;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createTaxonBag");
      }
      // verify the required parameter 'taxonBag' is set
      if (taxonBag === undefined || taxonBag === null) {
        throw new Error("Missing the required parameter 'taxonBag' when calling createTaxonBag");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonBagRead;
      return this.apiClient.callApi(
        '/taxonomies/bags', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createTaxonVersion operation.
     * @callback module:api/TaxonomyApi~createTaxonVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Taxon resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {module:model/TaxonVersionWrite} taxon Required properties are: * title   For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/TaxonomyApi~createTaxonVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonVersionRead}
     */
    createTaxonVersion(acceptLanguage, taxonomyName, taxonId, taxon, callback) {
      let postBody = taxon;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createTaxonVersion");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling createTaxonVersion");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling createTaxonVersion");
      }
      // verify the required parameter 'taxon' is set
      if (taxon === undefined || taxon === null) {
        throw new Error("Missing the required parameter 'taxon' when calling createTaxonVersion");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createTaxonomy operation.
     * @callback module:api/TaxonomyApi~createTaxonomyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonomyRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Taxonomy resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {module:model/TaxonomyCreate} taxonomy Required properties are: * name * nestable * sortable 
     * @param {module:api/TaxonomyApi~createTaxonomyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonomyRead}
     */
    createTaxonomy(acceptLanguage, taxonomy, callback) {
      let postBody = taxonomy;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createTaxonomy");
      }
      // verify the required parameter 'taxonomy' is set
      if (taxonomy === undefined || taxonomy === null) {
        throw new Error("Missing the required parameter 'taxonomy' when calling createTaxonomy");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonomyRead;
      return this.apiClient.callApi(
        '/taxonomies', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteContentTaxon operation.
     * @callback module:api/TaxonomyApi~deleteContentTaxonCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the ContentTaxon resource.
     * @param {String} entityName 
     * @param {String} entityId 
     * @param {String} bagName 
     * @param {String} id 
     * @param {module:api/TaxonomyApi~deleteContentTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteContentTaxon(entityName, entityId, bagName, id, callback) {
      let postBody = null;
      // verify the required parameter 'entityName' is set
      if (entityName === undefined || entityName === null) {
        throw new Error("Missing the required parameter 'entityName' when calling deleteContentTaxon");
      }
      // verify the required parameter 'entityId' is set
      if (entityId === undefined || entityId === null) {
        throw new Error("Missing the required parameter 'entityId' when calling deleteContentTaxon");
      }
      // verify the required parameter 'bagName' is set
      if (bagName === undefined || bagName === null) {
        throw new Error("Missing the required parameter 'bagName' when calling deleteContentTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteContentTaxon");
      }

      let pathParams = {
        'entity_name': entityName,
        'entity_id': entityId,
        'bag_name': bagName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/{entity_name}/{entity_id}/taxons/{bag_name}/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteTaxon operation.
     * @callback module:api/TaxonomyApi~deleteTaxonCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Taxon resource.
     * @param {String} taxonomyName 
     * @param {String} id 
     * @param {module:api/TaxonomyApi~deleteTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteTaxon(taxonomyName, id, callback) {
      let postBody = null;
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling deleteTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteTaxon");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteTaxonBag operation.
     * @callback module:api/TaxonomyApi~deleteTaxonBagCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the TaxonBag resource.
     * @param {String} id 
     * @param {module:api/TaxonomyApi~deleteTaxonBagCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteTaxonBag(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteTaxonBag");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/taxonomies/bags/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteTaxonomy operation.
     * @callback module:api/TaxonomyApi~deleteTaxonomyCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Taxonomy resource.
     * @param {String} id 
     * @param {module:api/TaxonomyApi~deleteTaxonomyCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteTaxonomy(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteTaxonomy");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/taxonomies/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getContentTaxon operation.
     * @callback module:api/TaxonomyApi~getContentTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContentTaxonRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a ContentTaxon resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} entityName 
     * @param {String} entityId 
     * @param {String} bagName 
     * @param {String} id 
     * @param {module:api/TaxonomyApi~getContentTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContentTaxonRead}
     */
    getContentTaxon(acceptLanguage, entityName, entityId, bagName, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getContentTaxon");
      }
      // verify the required parameter 'entityName' is set
      if (entityName === undefined || entityName === null) {
        throw new Error("Missing the required parameter 'entityName' when calling getContentTaxon");
      }
      // verify the required parameter 'entityId' is set
      if (entityId === undefined || entityId === null) {
        throw new Error("Missing the required parameter 'entityId' when calling getContentTaxon");
      }
      // verify the required parameter 'bagName' is set
      if (bagName === undefined || bagName === null) {
        throw new Error("Missing the required parameter 'bagName' when calling getContentTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getContentTaxon");
      }

      let pathParams = {
        'entity_name': entityName,
        'entity_id': entityId,
        'bag_name': bagName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ContentTaxonRead;
      return this.apiClient.callApi(
        '/{entity_name}/{entity_id}/taxons/{bag_name}/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getContentTaxonList operation.
     * @callback module:api/TaxonomyApi~getContentTaxonListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ContentTaxonList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of ContentTaxon resources.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} entityName 
     * @param {String} entityId 
     * @param {String} bagName 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search The `search` property concatenates all supported search and order-by fields, to filter results and sort them in the specified order. It must be a valid StringQuery value. For in-depth documentation on how to construct it and which operators are supported, see the [RollerworksSearch documentation](https://rollerworkssearch.readthedocs.io/en/latest/reference/input/string_query.html).  Supported search fields are:  * **client** (text) * **owned_by** (text) * **taxon** (text)  Supported order-by fields are:  * position * created_at  ### Examples ---  Search by taxon: ``` taxon:93a605a4-0ebc-11eb-adc1-0242ac120002 ``` 
     * @param {Number} opts.page The list page number
     * @param {module:api/TaxonomyApi~getContentTaxonListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ContentTaxonList>}
     */
    getContentTaxonList(acceptLanguage, entityName, entityId, bagName, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getContentTaxonList");
      }
      // verify the required parameter 'entityName' is set
      if (entityName === undefined || entityName === null) {
        throw new Error("Missing the required parameter 'entityName' when calling getContentTaxonList");
      }
      // verify the required parameter 'entityId' is set
      if (entityId === undefined || entityId === null) {
        throw new Error("Missing the required parameter 'entityId' when calling getContentTaxonList");
      }
      // verify the required parameter 'bagName' is set
      if (bagName === undefined || bagName === null) {
        throw new Error("Missing the required parameter 'bagName' when calling getContentTaxonList");
      }

      let pathParams = {
        'entity_name': entityName,
        'entity_id': entityId,
        'bag_name': bagName
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [ContentTaxonList];
      return this.apiClient.callApi(
        '/{entity_name}/{entity_id}/taxons/{bag_name}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxon operation.
     * @callback module:api/TaxonomyApi~getTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a Taxon resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} id 
     * @param {module:api/TaxonomyApi~getTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonRead}
     */
    getTaxon(acceptLanguage, taxonomyName, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getTaxon");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonBag operation.
     * @callback module:api/TaxonomyApi~getTaxonBagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonBagRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a TaxonBag resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/TaxonomyApi~getTaxonBagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonBagRead}
     */
    getTaxonBag(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonBag");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getTaxonBag");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonBagRead;
      return this.apiClient.callApi(
        '/taxonomies/bags/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonBagList operation.
     * @callback module:api/TaxonomyApi~getTaxonBagListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/TaxonBagList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of TaxonBag resources.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {Object} opts Optional parameters
     * @param {String} opts.search The `search` property concatenates all supported search and order-by fields, to filter results and sort them in the specified order. It must be a valid StringQuery value. For in-depth documentation on how to construct it and which operators are supported, see the [RollerworksSearch documentation](https://rollerworkssearch.readthedocs.io/en/latest/reference/input/string_query.html).  Supported search fields are:  * **id** (text) * **client** (text) * **created_at** (datetime) * **name** (text) * **scope** (text) * **distinct** (text) * **sortable** (text)  Supported order-by fields are:  * created_at * updated_at * name  ### Examples ---  Text field containing the search term, and a date greater than or equal to the specified value: ``` name:something;created_at:>=2000-01-01T00:00:00Z ```  Search where date between two values, order by name (ascending): ``` created_at:2020-01-01T00:00:00Z~2021-12-31T00:00:00Z;@name:ASC ``` 
     * @param {Number} opts.page The list page number
     * @param {module:api/TaxonomyApi~getTaxonBagListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/TaxonBagList>}
     */
    getTaxonBagList(acceptLanguage, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonBagList");
      }

      let pathParams = {
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [TaxonBagList];
      return this.apiClient.callApi(
        '/taxonomies/bags', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonList operation.
     * @callback module:api/TaxonomyApi~getTaxonListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/TaxonList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Taxon resources.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search The `search` property concatenates all supported search and order-by fields, to filter results and sort them in the specified order. It must be a valid StringQuery value. For in-depth documentation on how to construct it and which operators are supported, see the [RollerworksSearch documentation](https://rollerworkssearch.readthedocs.io/en/latest/reference/input/string_query.html).  Supported search fields are:  * **id** (text) * **client** (text) * **owned_by** (text) * **owned_by_display_name** (text) * **created_at** (datetime) * **title** (text) * **slug** (text) * **slug__keyword** (text, exact match) * **description** (text) * **parent** (text) * **origin** (text) * **depth** (integer) * **state** (text) * **published_at** (datetime) * **root** (text)  Supported order-by fields are:  * position * created_at * updated_at * title * slug * published_at  ### Examples ---  Text field containing the search term, and a date greater than or equal to the specified value: ``` title:something;created_at:>=2000-01-01T00:00:00Z ```  Search by origin identifier: ``` origin:T-0123 ```  Search where date between two values, order by title (ascending): ``` created_at:2020-01-01T00:00:00Z~2021-12-31T00:00:00Z;@title:ASC ```  Search by numeric extended attribute (always prefixed with *attr_*), having a value greater than: ``` attr_number_of_likes:>10 ``` 
     * @param {Number} opts.page The list page number
     * @param {module:api/TaxonomyApi~getTaxonListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/TaxonList>}
     */
    getTaxonList(acceptLanguage, taxonomyName, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonList");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonList");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [TaxonList];
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonState operation.
     * @callback module:api/TaxonomyApi~getTaxonStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of Taxon resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} id 
     * @param {module:api/TaxonomyApi~getTaxonStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonState}
     */
    getTaxonState(acceptLanguage, taxonomyName, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonState");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getTaxonState");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonState;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonVersion operation.
     * @callback module:api/TaxonomyApi~getTaxonVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Taxon resource version.
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {module:api/TaxonomyApi~getTaxonVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonVersionRead}
     */
    getTaxonVersion(taxonomyName, taxonId, id, callback) {
      let postBody = null;
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonVersion");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getTaxonVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getTaxonVersion");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonVersionList operation.
     * @callback module:api/TaxonomyApi~getTaxonVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/TaxonVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Taxon versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/TaxonomyApi~getTaxonVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/TaxonVersionList>}
     */
    getTaxonVersionList(acceptLanguage, taxonomyName, taxonId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonVersionList");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonVersionList");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getTaxonVersionList");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [TaxonVersionList];
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonomy operation.
     * @callback module:api/TaxonomyApi~getTaxonomyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonomyRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a Taxonomy resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/TaxonomyApi~getTaxonomyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonomyRead}
     */
    getTaxonomy(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonomy");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getTaxonomy");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonomyRead;
      return this.apiClient.callApi(
        '/taxonomies/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonomyList operation.
     * @callback module:api/TaxonomyApi~getTaxonomyListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/TaxonomyList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Taxonomy resources.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {Object} opts Optional parameters
     * @param {String} opts.search The `search` property concatenates all supported search and order-by fields, to filter results and sort them in the specified order. It must be a valid StringQuery value. For in-depth documentation on how to construct it and which operators are supported, see the [RollerworksSearch documentation](https://rollerworkssearch.readthedocs.io/en/latest/reference/input/string_query.html).  Supported search fields are:  * **id** (text) * **client** (text) * **created_at** (datetime) * **name** (text) * **nestable** (text) * **sortable** (text) * **scope** (text)  Supported order-by fields are:  * created_at * updated_at  ### Examples ---  Text field containing the search term, and a date greater than or equal to the specified value: ``` name:something;created_at:>=2000-01-01T00:00:00Z ```  Search where date between two values, order by name (ascending): ``` created_at:2020-01-01T00:00:00Z~2021-12-31T00:00:00Z;@name:ASC ``` 
     * @param {Number} opts.page The list page number
     * @param {module:api/TaxonomyApi~getTaxonomyListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/TaxonomyList>}
     */
    getTaxonomyList(acceptLanguage, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonomyList");
      }

      let pathParams = {
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [TaxonomyList];
      return this.apiClient.callApi(
        '/taxonomies', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setTaxonState operation.
     * @callback module:api/TaxonomyApi~setTaxonStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of Taxon resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} id 
     * @param {module:model/TaxonStateUpdate} taxon The updated Taxon resource
     * @param {module:api/TaxonomyApi~setTaxonStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonState}
     */
    setTaxonState(acceptLanguage, taxonomyName, id, taxon, callback) {
      let postBody = taxon;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setTaxonState");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling setTaxonState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setTaxonState");
      }
      // verify the required parameter 'taxon' is set
      if (taxon === undefined || taxon === null) {
        throw new Error("Missing the required parameter 'taxon' when calling setTaxonState");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonState;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateTaxon operation.
     * @callback module:api/TaxonomyApi~updateTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Taxon resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} id 
     * @param {module:model/TaxonUpdate} taxon Required properties are: * title   For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/TaxonomyApi~updateTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonRead}
     */
    updateTaxon(acceptLanguage, taxonomyName, id, taxon, callback) {
      let postBody = taxon;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling updateTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateTaxon");
      }
      // verify the required parameter 'taxon' is set
      if (taxon === undefined || taxon === null) {
        throw new Error("Missing the required parameter 'taxon' when calling updateTaxon");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateTaxonBag operation.
     * @callback module:api/TaxonomyApi~updateTaxonBagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonBagRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the TaxonBag resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/TaxonBagUpdate} taxonBag Required properties are: * name * sortable 
     * @param {module:api/TaxonomyApi~updateTaxonBagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonBagRead}
     */
    updateTaxonBag(acceptLanguage, id, taxonBag, callback) {
      let postBody = taxonBag;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateTaxonBag");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateTaxonBag");
      }
      // verify the required parameter 'taxonBag' is set
      if (taxonBag === undefined || taxonBag === null) {
        throw new Error("Missing the required parameter 'taxonBag' when calling updateTaxonBag");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonBagRead;
      return this.apiClient.callApi(
        '/taxonomies/bags/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateTaxonVersion operation.
     * @callback module:api/TaxonomyApi~updateTaxonVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Taxon resource version.
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {module:model/TaxonVersionWrite} taxon Required properties are: * title   For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/TaxonomyApi~updateTaxonVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonVersionRead}
     */
    updateTaxonVersion(taxonomyName, taxonId, id, taxon, callback) {
      let postBody = taxon;
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling updateTaxonVersion");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling updateTaxonVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateTaxonVersion");
      }
      // verify the required parameter 'taxon' is set
      if (taxon === undefined || taxon === null) {
        throw new Error("Missing the required parameter 'taxon' when calling updateTaxonVersion");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateTaxonVersionOptions operation.
     * @callback module:api/TaxonomyApi~updateTaxonVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Taxon resource version options.
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject21} opts.taxon 
     * @param {module:api/TaxonomyApi~updateTaxonVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonVersionRead}
     */
    updateTaxonVersionOptions(taxonomyName, taxonId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['taxon'];
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling updateTaxonVersionOptions");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling updateTaxonVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateTaxonVersionOptions");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateTaxonomy operation.
     * @callback module:api/TaxonomyApi~updateTaxonomyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonomyRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Taxonomy resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/TaxonomyUpdate} taxonomy Required properties are: * name * sortable 
     * @param {module:api/TaxonomyApi~updateTaxonomyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonomyRead}
     */
    updateTaxonomy(acceptLanguage, id, taxonomy, callback) {
      let postBody = taxonomy;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateTaxonomy");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateTaxonomy");
      }
      // verify the required parameter 'taxonomy' is set
      if (taxonomy === undefined || taxonomy === null) {
        throw new Error("Missing the required parameter 'taxonomy' when calling updateTaxonomy");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonomyRead;
      return this.apiClient.callApi(
        '/taxonomies/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
